import React, { useEffect, useLayoutEffect, useState } from 'react';
import { GetOrgUserList, setShowPopUp, setSelectedHetPay, saveToHistory, setActionType } from './OrgUsersManagementSlice';
import { connect } from 'react-redux';
import UploadOrgUserList from './UploadFile/UploadOrgUserList';
import OrgUsersTable from './OrgUsersTable';
import { PopUp, EnumStep } from './General';
import GeneralPopUp from './PopUp/GeneralPopUp';
import Popup from '../../Shared/Popup/PopUp';
import UpdateUserPopUp from './PopUp/UpdateUserPopUp';
import { isMobile } from 'react-device-detect';
import Config from '../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import { getOrganizationsDataForCompanies } from '../PortalsBlock/portalSlice';

const OrgUsersManagement = (props) => {

  const orgData = props.companyOrgDataMap?.[props.selectedHetPayId];
  const allowUpgrade = orgData?.allowPortalUpgradeUser.value;
  const allowActivate = orgData?.allowPortal.value;

  useEffect(() => {
    if (props.privateCompanyList?.length && !orgData) {
      props.getOrganizationsDataForCompanies(props.privateCompanyList);
    }
  }, [props.privateCompanyList, orgData, props.getOrganizationsDataForCompanies]);


  useLayoutEffect(() => {
    if (!props.selectedHetPay) {
      EpiContext.navigateTo(Config.businessLobbyUrl);
    }
  }, []);

  useEffect(() => {
    props.setSelectedHetPay(props.selectedHetPay);
    
    const GetOrgUsers = async () => {
      await props.GetOrgUserList(props.data.currentPage);
    };
    GetOrgUsers();
  }, [allowUpgrade, allowActivate ,props.setActionType]);

  return (
    <div>
      {(props.data.currentStep == EnumStep.UploadFile || isMobile) ? <UploadOrgUserList iContent={props.iContent} allowActivate={allowActivate} allowUpgrade={allowUpgrade} /> : <OrgUsersTable allowActivate={allowActivate} allowUpgrade={allowUpgrade} />}
      <Popup className='userManagementPopUp' showPopUp={props.data.showPopup} onClose={() => props.setShowPopUp({ show: false })}>
        {props.data.currentPopup == PopUp.UpdateUser ? <UpdateUserPopUp /> : <GeneralPopUp />}
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.orgUsersManagement,
    selectedHetPay: state.portalsBlock.selectedHetPay,
    selectedHetPayId: state.portalsBlock.selectedHetPayId,
    companyOrgDataMap: state.portalsBlock.companyOrgDataMap,
    privateCompanyList: state.portalsBlock.privateCompanyList,
  };
};

const mapDispatchToProps = {
  GetOrgUserList,
  setShowPopUp,
  setSelectedHetPay,
  setActionType,
  saveToHistory,
  getOrganizationsDataForCompanies,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgUsersManagement);
